import { combineReducers } from "redux";
import apiFetchReducer from "./api_fetch";
import appsReducer from "./apps";
import authReducer from "./auth";
import categoriesReducer from "./categories";
import appDetailsReducer from "./appDetails";
import countriesReducer from "./countries";
import vehiclesReducer from "./vehicles";
import validationReducer from "./validation";
import notificationReducer from "./notifications";
import ageRatingReducer from "./ageRating";
import oemAnalyticsRevisedReducer from "./oemAnalytics";
import devAnalyticsReducer from "./devAnalytics";
import featureSettingsReducer from "./featureSettings";
import appstoreVersionReducer from "./appstoreVersion";

export default combineReducers({
    authDetails: authReducer,
    apiDetails: apiFetchReducer,
    categories: categoriesReducer,
    listOfApps: appsReducer,
    appDetails: appDetailsReducer,
    countriesList: countriesReducer,
    vehiclesList: vehiclesReducer,
    validationList: validationReducer,
    notifications: notificationReducer,
    ageRatingList: ageRatingReducer,
    oemAnalyticsRevisedData: oemAnalyticsRevisedReducer,
    devAnalyticsData: devAnalyticsReducer,
    featureSettings: featureSettingsReducer,
    appstoreVersion: appstoreVersionReducer,
});
